module.exports = __webpack_public_path__ + "static/media/position-upm.eaa3b029.jpg";